// src/pages/Managers.js
import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Managers.css';

const Managers = () => {
    const [managers, setManagers] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        API.get('/managers')
            .then(res => setManagers(res.data))
            .catch(console.error);
    }, []);

    const loadDetail = (id) => {
        Promise.all([
            API.get(`/managers/${id}`),
            API.get(`/managers/${id}/subscription`)
        ])
            .then(([detailRes, subRes]) => {
                setSelected({ ...detailRes.data, subscription: subRes.data });
            })
            .catch(console.error);
    };

    const handleApprove = async (subscriptionId, managerId) => {
        try {
            await API.put(`/managers/${managerId}/approve-subscription`, { subscriptionId });
            alert('Subscription approved!');
            loadDetail(managerId); // refresh
        } catch (err) {
            alert('Approval failed: ' + (err.response?.data?.error || err.message));
        }
    };

    return (
        <div className="managers-page">
            <h1>👑 VIP Managers</h1>
            <div className="managers-grid">
                {managers.map(mgr => (
                    <div key={mgr.id} className="manager-card" onClick={() => loadDetail(mgr.id)}>
                        <div className="manager-avatar">
                            {mgr.full_name?.[0]?.toUpperCase() || 'M'}
                        </div>
                        <div className="manager-info">
                            <h3>{mgr.full_name || mgr.username}</h3>
                            <p>@{mgr.username}</p>
                            <span className="group-name">{mgr.group_title || 'Grup Yok'}</span>
                        </div>
                        <div className="manager-stats">
                            <div className="stat">
                                <span className="stat-num">{mgr.member_count ?? 0} + {mgr.active_members ?? 0}</span>
                                <span className="stat-lbl">toplam + yeni üye</span>
                            </div>
                            <div className="stat">
                                <span className="stat-num">{mgr.total_revenue} USDT</span>
                                <span className="stat-lbl">gelir</span>
                            </div>
                        </div>
                        <span className={`status-badge ${mgr.group_active ? 'active' : 'inactive'}`}>
                            {mgr.group_active ? 'Aktif' : 'Pasif'}
                        </span>
                    </div>
                ))}
            </div>

            {selected && (
                <div className="detail-modal" onClick={() => setSelected(null)}>
                    <div className="detail-content" onClick={e => e.stopPropagation()}>
                        <button className="close-btn" onClick={() => setSelected(null)}>×</button>
                        <h2>{selected.manager.full_name || selected.manager.username}</h2>
                        <p>@{selected.manager.username}</p>

                        {/* Subscription bloğu - üyelerden bağımsız */}
                        {selected.subscription && (
                            <div className="subscription-info" style={{ marginBottom: '20px', padding: '16px', background: 'rgba(99,102,241,0.05)', borderRadius: '12px', border: '1px solid rgba(99,102,241,0.2)' }}>
                                <h3 style={{ color: '#a5b4fc', marginBottom: '12px' }}>📋 Subscription</h3>
                                <div className="detail-grid">
                                    <div><span>Plan:</span> {selected.subscription?.plan_name || 'N/A'}</div>
                                    <div><span>Amount:</span> {selected.subscription?.amount || 0} {selected.subscription?.currency || 'USDT'}</div>
                                    <div><span>Start:</span> {selected.subscription?.start_date ? new Date(selected.subscription.start_date).toLocaleDateString('en-US') : 'N/A'}</div>
                                    <div><span>End:</span> {selected.subscription?.end_date ? new Date(selected.subscription.end_date).toLocaleDateString('en-US') : 'N/A'}</div>
                                    <div><span>Status:</span> <span className={`status-tag ${selected.subscription?.status}`}>{selected.subscription?.status || 'N/A'}</span></div>
                                    <div><span>Payment:</span> {selected.subscription?.payment_method || 'N/A'} ({selected.subscription?.payment_status || 'N/A'})</div>
                                </div>
                                {selected.subscription?.payment_status === 'pending' && (
                                    <button
                                        onClick={() => handleApprove(selected.subscription.id, selected.manager.id)}
                                        style={{
                                            marginTop: '12px',
                                            padding: '10px 20px',
                                            background: '#4ade80',
                                            color: '#000',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontWeight: 'bold',
                                            cursor: 'pointer',
                                            width: '100%'
                                        }}
                                    >
                                        ✅ Approve Payment
                                    </button>
                                )}
                            </div>
                        )}

                        <div className="detail-section">
                            <h3>Üyeler ({selected.members.length})</h3>
                            {selected.members.map(m => (
                                <div key={m.id} className="member-item">
                                    <span>@{m.username || m.telegram_id}</span>
                                    <span>{m.package_name}</span>
                                    <span className={m.status}>{m.status}</span>
                                </div>
                            ))}
                        </div>

                        <div className="detail-section">
                            <h3>Son Ödemeler</h3>
                            {selected.payments.slice(0, 5).map(p => (
                                <div key={p.id} className="payment-item">
                                    <span>{p.amount} {p.currency}</span>
                                    <span>{p.status}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Managers;